import { render, staticRenderFns } from "./SetConcessionPayment.vue?vue&type=template&id=f99d9a68&scoped=true"
import script from "./SetConcessionPayment.vue?vue&type=script&lang=js"
export * from "./SetConcessionPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f99d9a68",
  null
  
)

export default component.exports